import { useLottie } from "lottie-react";
import loadingAnimation from "assets/lottie/loader-dots.json";
 
const LoadingAnimation = () => {
  const options = {
    animationData: loadingAnimation,
    loop: true,
    autoplay: true,
  };
 
  const { View } = useLottie(options);
 
  return View;
};
 
export default LoadingAnimation;